<template>
  <workbench />
</template>
<script>
import workbench from '@/views/workbench/index.vue'
export default {
  name: 'welcome',
  components: { workbench },
}
</script>
